import panzoom from "@panzoom/panzoom";
let isMapOpen = false;
let mapState = 0;
let isMobile = false;
let isHome = false;
let timeoutResult = null;
let curEstado = null;
let showingResult = false;
// map states
// 0. closed (default)
// 1. half open
// 2. full open

function closeMapa() {
  isMapOpen = !isMapOpen;
  mapState = 0;
  let mapa = document.querySelector("#mapa");
  mapa.classList.toggle("active");

  if (mapa.classList.contains("full")) {
    mapa.classList.toggle("full");
  }

  if (document.body.classList.contains("map-open")) {
    document.body.classList.toggle("map-open");
  }

  if (document.body.classList.contains("lock")) {
    document.body.classList.toggle("lock");
  }
}

function openMapa() {
  isMapOpen = true;
  let mapa = document.querySelector("#mapa");
  mapa.classList.toggle("active");
  if (isMobile) {
    openFullMapa();
    return;
  }
  document.body.classList.toggle("map-open");
  mapState = 1;
}

function openFullMapa() {
  isMapOpen = true;
  mapState = 2;
  let mapa = document.querySelector("#mapa");
  mapa.classList.toggle("full");
  document.body.classList.toggle("lock");
  atualizarAlturaInfo();
}

document.addEventListener("DOMContentLoaded", function () {
  //   check if mobile
  if (window.innerWidth < 768) {
    isMobile = true;
  }

  if (document.querySelector("body").classList.contains("home")) {
    isHome = true;
  }

  if (!isMobile && isHome) {
    openMapa();
  }

  let mapaOpenBtns = document.querySelectorAll(".toggle-map");
  let mapaCloseBtns = document.querySelectorAll(".close-map");
  let mapaFullBtns = document.querySelectorAll(".full-map");
  let closeInfoBtn = document.querySelectorAll(".close-info");

  mapaOpenBtns.forEach((btn) => {
    btn.addEventListener("click", openMapa);
  });

  mapaCloseBtns.forEach((btn) => {
    btn.addEventListener("click", closeMapa);
  });

  mapaFullBtns.forEach((btn) => {
    btn.addEventListener("click", openFullMapa);
  });

  closeInfoBtn.forEach((btn) => {
    btn.addEventListener("click", closeInfo);
  });

  //   on esc
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      if (isMapOpen) {
        closeMapa();
      }
    }
  });

  let elem = document.getElementById("svg");
  if (elem) {
    var instance = panzoom(elem, {
      maxScale: 4,
      minScale: 1,
      step: 0.2,
    });

    // interactable btn
    let zoomInBtn = document.querySelector("#zoom-in");
    let zoomOutBtn = document.querySelector("#zoom-out");

    zoomInBtn.addEventListener("click", instance.zoomIn);
    zoomOutBtn.addEventListener("click", instance.zoomOut);

    // Bind to mousewheel
    elem.parentElement.addEventListener("wheel", instance.zoomWithWheel);
    // Bind to shift+mousewheel
    elem.parentElement.addEventListener("wheel", function (event) {
      if (!event.shiftKey) return;
      // Panzoom will automatically use `deltaX` here instead
      // of `deltaY`. On a mac, the shift modifier usually
      // translates to horizontal scrolling, but Panzoom assumes
      // the desired behavior is zooming.
      instance.zoomWithWheel(event);
      // stop propagation so the page doesn't scroll
      event.stopPropagation();
    });

    let isZooming = false;
    let zoomingTimeout = null;
    elem.addEventListener("panzoompan", function (e) {
      isZooming = true;

      if (zoomingTimeout) {
        clearTimeout(zoomingTimeout);
      }
      zoomingTimeout = setTimeout(() => {
        isZooming = false;
      }, 300);
    });
    let actualMap = document.querySelector("#actual-map");
    if (actualMap) {
      // Add click event listener to each estado element
      let estados = document.querySelectorAll("#actual-map > g:not(.bad)");
      estados.forEach((estado) => {
        estado.addEventListener("click", function (e) {
          if (!isZooming) {
            if (showingResult == false) {
              showingResult = true;
              showEstado(estado.id);
            }
          }
        });
      });
    }
  }

  let hemocentroSelect = document.querySelector("#hemocentro-select");

  if (hemocentroSelect) {
    hemocentroSelect.addEventListener("change", function () {
      if (this.value == "0") return;
      let hemocentro = this.value;
      if (showingResult == false) {
        showingResult = true;
        showEstado(hemocentro);
      }
    });
  }
});

// on windwo resize
window.addEventListener("resize", function () {
  if (window.innerWidth < 768) {
    isMobile = true;
  } else {
    isMobile = false;
  }
});

function showLoading() {
  let content = document.querySelector("#content-hemocentro");
  let resultado = document.querySelector("#resultado-hemocentros");
  let loading = document.querySelector("#resultado-hemocentros .loading");
  content.innerHTML = "";
  resultado.classList.add("active");
  resultado.style.height = 160 + "px";
  activateInfo();
  setTimeout(() => {
    resultado.classList.add("loading");
  }, 200);
}

function activateInfo() {
  let resultado = document.querySelector("#resultado-hemocentros");
  resultado.classList.add("active");
}

function showEstado(estado) {
  if (curEstado !== estado) {
    showLoading();
    curEstado = estado;
    let currentUrl = window.location.href;
    if (currentUrl.split("/")[2] == "localhost") {
      currentUrl = "http://localhost/hemocentros-unidos/";
    } else if (currentUrl.split("/")[2] == "luccabarroso.com.br") {
      currentUrl = "https://luccabarroso.com.br/dev/hemocentros-unidos/";
    } else {
      currentUrl = "https://www.hemocentrosunidos.org.br/";
    }

    const endpoint = `${currentUrl}wp-json/wp/v2/hemocentros?slug=${estado.toLowerCase()}&_embed`;
    fetch(endpoint)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          timeoutResult = setTimeout(() => {
            showHemocentro(data[0]);
            showingResult = false;
          }, 1500);
        } else {
          timeoutResult = setTimeout(() => {
            showHemocentro(null);
            showingResult = false;
          }, 1500);
        }
      })
      .catch((error) => console.error("teste"));
  } else {
    activateInfo();
    let resultado = document.querySelector("#resultado-hemocentros");
    let content = document.querySelector("#content-hemocentro");
    resultado.style.height = content.offsetHeight + 40 + "px";
    showingResult = false;
  }
}

function showHemocentro(hemocentro) {
  let content = document.querySelector("#content-hemocentro");
  if (hemocentro) {
    let thumbnailUrl = hemocentro._embedded["wp:featuredmedia"][0].source_url;
    let linkMaps = hemocentro.crb_hemocentro_link_maps;
    let linkSite = hemocentro.crb_hemocentro_site;

    content.innerHTML = `
      <div class="thumbnail">
        <img src="${thumbnailUrl}" alt="">
      </div>
      <div class="info">
        <a class="btn-border-red btn-arrow" href="${linkSite}" target="_blank">
        Visitar site
        <svg width="234" height="111" viewBox="0 0 234 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M172.449 2.25696C175.458 -0.752319 180.337 -0.752319 183.347 2.25696L230.945 49.8555C231.675 50.5859 232.229 51.4263 232.604 52.3235C233.831 55.1423 233.292 58.5447 230.986 60.8503L183.385 108.452C180.375 111.461 175.496 111.461 172.487 108.452C169.478 105.443 169.478 100.564 172.487 97.5542L207.233 62.8081H8C3.58179 62.8081 0 59.2263 0 54.8081C0 50.3899 3.58167 46.8081 8 46.8081H206.102L172.449 13.1548C169.439 10.1454 169.439 5.26636 172.449 2.25696Z" fill="#C02C31"></path>
                </svg>
        </a>
        <a class="btn-border-red btn-arrow" href="${linkMaps}" target="_blank">
        Ver no mapa
        
        <svg width="234" height="111" viewBox="0 0 234 111" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M172.449 2.25696C175.458 -0.752319 180.337 -0.752319 183.347 2.25696L230.945 49.8555C231.675 50.5859 232.229 51.4263 232.604 52.3235C233.831 55.1423 233.292 58.5447 230.986 60.8503L183.385 108.452C180.375 111.461 175.496 111.461 172.487 108.452C169.478 105.443 169.478 100.564 172.487 97.5542L207.233 62.8081H8C3.58179 62.8081 0 59.2263 0 54.8081C0 50.3899 3.58167 46.8081 8 46.8081H206.102L172.449 13.1548C169.439 10.1454 169.439 5.26636 172.449 2.25696Z" fill="#C02C31"></path>
                </svg>
        </a>
      </div>
    `;
  } else {
    content.innerHTML = `
    <div class="no-results">
      <p>Ainda não cadastramos esse hemocentro!</p>
    </div> 
    `;
  }
  let resultado = document.querySelector("#resultado-hemocentros");
  // delay 300 ms
  setTimeout(() => {
    content = document.querySelector("#content-hemocentro");
    resultado.style.height = content.offsetHeight + 40 + "px";
    hideLoading();
  }, 300);
}

function hideLoading() {
  let resultado = document.querySelector("#resultado-hemocentros");
  resultado.classList.remove("loading");
}

function closeInfo() {
  let resultado = document.querySelector("#resultado-hemocentros");
  resultado.classList.remove("active");
  resultado.style.height = 0;
  clearTimeout(timeoutResult);
}

function atualizarAlturaInfo() {
  let resultado = document.querySelector("#resultado-hemocentros");
  if (resultado.style.height !== "0px" && resultado.style.height !== "") {
    setTimeout(() => {
      let content = document.querySelector("#content-hemocentro");
      resultado.style.height = content.offsetHeight + 40 + "px";
    }, 700);
  }
}
